var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Select } from '@ngxs/store';
import { DriveState } from '../../state/drive-state';
import { Observable, fromEvent } from 'rxjs';
var BaseDropTarget = /** @class */ (function () {
    function BaseDropTarget() {
        this.subs = [];
    }
    BaseDropTarget.prototype.ngOnInit = function () {
        var _this = this;
        this.dragging.subscribe(function (dragging) {
            if (dragging) {
                _this.onDragStart();
            }
            else {
                _this.onDragEnd();
            }
        });
    };
    BaseDropTarget.prototype.ngOnDestroy = function () {
        this.unsubscribe();
    };
    BaseDropTarget.prototype.onDragStart = function () {
        var _this = this;
        var enter = fromEvent(this.el.nativeElement, 'mouseenter')
            .subscribe(function () { return _this.onDragEnter(); });
        var leave = fromEvent(this.el.nativeElement, 'mouseleave')
            .subscribe(function () { return _this.onDragLeave(); });
        this.subs.push(enter, leave);
    };
    BaseDropTarget.prototype.onDragEnter = function () {
        var _a;
        var canDrop = this.canDrop(), classes = ['drag-over'];
        if (canDrop) {
            this.active = true;
            classes.push('can-drop');
        }
        (_a = this.el.nativeElement.classList).add.apply(_a, classes);
    };
    BaseDropTarget.prototype.onDragLeave = function () {
        this.active = false;
        this.removeDragOverClass();
    };
    BaseDropTarget.prototype.onDragEnd = function () {
        this.unsubscribe();
        this.removeDragOverClass();
        // pointer never left element before drag stop,
        // we can assume that user dropped on this el
        if (this.active && this.canDrop()) {
            this.executeAction();
            this.active = false;
        }
    };
    BaseDropTarget.prototype.unsubscribe = function () {
        this.subs.forEach(function (sub) { return sub && sub.unsubscribe(); });
    };
    BaseDropTarget.prototype.removeDragOverClass = function () {
        var _a;
        (_a = this.el.nativeElement.classList).remove.apply(_a, ['drag-over', 'can-drop']);
    };
    __decorate([
        Select(DriveState.dragging),
        __metadata("design:type", Observable)
    ], BaseDropTarget.prototype, "dragging", void 0);
    return BaseDropTarget;
}());
export { BaseDropTarget };
